jQuery(function($) {
	if (!$('.menu').length)
		return;

	var isMenu = $('body').hasClass('single-menu');

	if(!isMenu){
		return
	}

	//check brightness of hex color
	function hexBrightness(hex) {
		// strip off any leading #
		hex = hex.replace('#', '');

		// convert rrggbb to decimal
		var r = Math.round(parseInt(hex.substr(0,2),16));
		var g = Math.round(parseInt(hex.substr(2,2),16));
		var b = Math.round(parseInt(hex.substr(4,2),16));

		return Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
	}

	function initializeMenu() {
		//get value of css variable accent-color
		var accent_color = $('.menu').css('--background-color');

		//check brightness of accent_color hex
		var brightness = hexBrightness(accent_color);

		//if brightness is less than 125, set disclaimer-color css variable to white
		if (brightness < 125) {
			$('.menu').css('--disclaimer-color', '#fff');
		} else {
			$('.menu').css('--disclaimer-color', '#000');
		}


		$('.menu .category_nav .category').first().addClass('active');
		//hide all menu categories except the first one
		$('.menu .menu_category').hide();
		$('.menu .menu_category').first().show();
	}

	//toggle .menu_container element when .menu_toggle is clicked if window width is less than 768px
	if (window.is_mobile) {
		$('.menu .menu_toggle, .menu .category').click(function(){
			$('.menu .menu_container').slideToggle(300);
			$('.menu_toggle').toggleClass('active')
		});
	}

	$('.menu .menu_category').each(function(){
		var category = $(this);
		var category_index = $('.menu .menu_category').index(category);
		category.attr('data-category-index', category_index);
	});

	$('.menu .menu_category').hide();

	$('.menu .category_nav .category').click(function(){
		var category = $(this);
		var category_index = $('.menu .category_nav .category').index(category);
		$('.menu .category_nav .category').removeClass('active');
		category.addClass('active');

		$('.menu .menu_category').fadeOut(300);
		setTimeout(function(){
			$('.menu .menu_category[data-category-index="' + category_index + '"]').fadeIn(300);
		}, 301);
	});

	initializeMenu();
});